const PRODUTOS_URL =
  "https://n8n.devops.multpex.com.br/webhook/7713976f-35ca-4262-a817-bde7990266e4";

/**
 * Busca a lista de produtos pré-configurada para seleção do agente de vendas.
 * @returns {Promise<Array<{nome_produto: string, ca_modelo: string, url_imagem: string}>>}
 */
export async function buscarProdutosParaSelecao() {
  const response = await fetch(PRODUTOS_URL);
  if (!response.ok) {
    throw new Error(`Erro ao buscar produtos: ${response.status}`);
  }
  const data = await response.json();
  // A API pode retornar um array direto ou um objeto com a lista
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.produtos)) return data.produtos;
  return [];
}

/**
 * Formata os produtos selecionados e a mensagem do usuário em um contexto
 * para ser injetado na chamada do agente.
 * @param {Array} produtosSelecionados
 * @param {string} mensagemUsuario
 * @returns {string}
 */
export function formatarContextoAgente(produtosSelecionados, mensagemUsuario) {
  const mapaPeriodicidade = {
    diario: "por dia",
    semanal: "por semana",
    mensal: "por mês",
    anual: "por ano",
  };

  const linhasProdutos = produtosSelecionados
    .filter((p) => p.quantidade > 0)
    .map((p) => {
      const periodicidade =
        mapaPeriodicidade[p.periodicidade] || p.periodicidade;
      return `- ${p.nome_produto} (CA: ${p.ca_modelo}): ${p.quantidade} unidades ${periodicidade}`;
    })
    .join("\n");

  const partesMensagem = [];

  if (mensagemUsuario && mensagemUsuario.trim()) {
    partesMensagem.push(mensagemUsuario.trim());
    partesMensagem.push("");
  }

  if (linhasProdutos) {
    partesMensagem.push("Consumo de EPIs informado pelo cliente:");
    partesMensagem.push(linhasProdutos);
  }

  return partesMensagem.join("\n");
}
